import { RcToastType } from '@rc-df/ds-web-components';

export const RcToastTypes = {
  Success: 'success' as RcToastType,
  Warning: 'warning' as RcToastType,
  Error: 'error' as RcToastType,
  Information: 'information' as RcToastType,
};
